export default {"src":"/_next/static/media/sblFavicon.0e602f3d.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};